import { render, staticRenderFns } from "./DraggableTopics.vue?vue&type=template&id=2db3e152&scoped=true&"
import script from "./DraggableTopics.vue?vue&type=script&lang=js&"
export * from "./DraggableTopics.vue?vue&type=script&lang=js&"
import style0 from "./DraggableTopics.vue?vue&type=style&index=0&id=2db3e152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db3e152",
  null
  
)

export default component.exports